/**
 * Whether the firm takes orders for later, as the desk's order form needs to know.
 *
 * Read once from `/api/tenant/current` and kept for the session: it is a firm's setting,
 * changed on a settings page and not between two calls. Assumed on until the answer arrives,
 * which is what every firm had, so the form never jumps for the many that keep it. The API
 * refuses an order for later when it is off whatever this says.
 */

import { useEffect, useState } from 'react';

import { request, type Schema } from '@taxi/api-client';

let asked: Promise<boolean> | null = null;

function ask(): Promise<boolean> {
  asked ??= request<Pick<Schema<'CurrentTenant'>, 'preBookingsEnabled'>>('/api/tenant/current').then(
    (firm) => firm.preBookingsEnabled !== false,
    () => true,
  );

  return asked;
}

/** Forgets the answer, for the settings page after it changes it. */
export function forgetPreBookingsSetting(): void {
  asked = null;
}

export function usePreBookingsEnabled(): boolean {
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    let current = true;

    void ask().then((answer) => {
      if (current) setEnabled(answer);
    });

    return () => {
      current = false;
    };
  }, []);

  return enabled;
}
